import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { achievementResourceType } from "./achievementResourceConsts";

export const achievementItemIdentifierStruct = createIdentifierStruct(
  achievementResourceType
);
